import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as SaBiaActions from './sa-bia.actions';
import { initialState } from './sa-bia.state';
export const saBiaFeatureKey = 'SaBIA';

export const reducer = createReducer(
  initialState,

  on(SaBiaActions.loadImpactTemplateSuccess, (state, { impactTemplates }) => ({
    ...state,
    impactTemplates,
  })),
  on(SaBiaActions.loadITGroupSuccess, (state, { iTGroups }) => ({
    ...state,
    maos: iTGroups.saMaos || [],
    rtos: iTGroups.saRtos || [],
    impactTypes: iTGroups.saImpactTypes || [],
    impactValues: iTGroups.saImpactValues || [],
    impactTemplates: iTGroups.saImpactTemplate,
  })),
  on(SaBiaActions.loadImpactTypeSuccess, (state, { impactTypes }) => ({
    ...state,
    impactTypes,
  })),
  on(SaBiaActions.loadImpactValueSuccess, (state, { impactValues }) => ({
    ...state,
    impactValues,
  })),
  on(SaBiaActions.loadMaoSuccess, (state, { maos }) => ({ ...state, maos })),
  on(SaBiaActions.loadSaRaIntQuesSuccess, (state, { raIntQues }) => ({
    ...state,
    raIntQues,
  })),
  on(SaBiaActions.addSaRaIntQuesSuccess, (state, action) => {
    const raq = state.raIntQues;
    const updatedState = {
      ...state,
      raIntQues: [...raq, action.raInternalQues],
    };
    return updatedState;
  }),
  on(SaBiaActions.updateSaRaIntQuesSuccess, (state, action) => {
    const inq = state.raIntQues;
    const updatedState = {
      ...state,
      raIntQues: inq.map((aps) =>
        aps.id === action.raInternalQues.id ? action.raInternalQues : aps
      ),
    };
    return updatedState;
  }),
  on(SaBiaActions.deleteSaRaIntQuesSuccess, (state, action) => {
    return {
      ...state,
      raIntQues: state.raIntQues.filter(
        (raIntQues) => raIntQues.id !== action.raInternalQues.id
      ),
    };
  }),
  on(SaBiaActions.addMaosSuccess, (state, action) => {
    const mo = state.maos;
    const rtos = action.rto ? [...state.rtos, action.rto] : state.rtos;
    const updatedState = {
      ...state,
      maos: [...mo, { ...action.maos, rto: action.rto }],
      rtos,
    };
    return updatedState;
  }),
  on(SaBiaActions.updateMaosSuccess, (state, action) => {
    const mo = state.maos.map((m) => {
      return m.id == action.maos.id ? { ...action.maos, rto: action.rto } : m;
    });
    const rtos = action.rto
      ? state.rtos.map((r) => (r.id == action.rto.id ? action.rto : r))
      : state.rtos;
    const updatedState = {
      ...state,
      maos: mo,
      rtos,
    };
    return updatedState;
  }),
  on(SaBiaActions.deleteMaoSuccess, (state, action) => {
    return {
      ...state,
      maos: state.maos.filter((mao) => mao.id !== action.mao.id),
    };
  }),
  on(SaBiaActions.addRtoSuccess, (state, action) => {
    const rto = state.rtos;
    const updatedState = {
      ...state,
      rtos: [...rto, action.rtos],
    };
    return updatedState;
  }),
  on(SaBiaActions.updateRtoSuccess, (state, action) => {
    const rto = state.rtos.map((r) =>
      r.id == action.rtos.id ? action.rtos : r
    );

    const updatedState = {
      ...state,
      rtos: rto,
    };
    return updatedState;
  }),
  on(SaBiaActions.deleteRtoSuccess, (state, action) => {
    return {
      ...state,
      rtos: state.rtos.filter((rto) => rto.id !== action.rto.id),
    };
  }),
  on(SaBiaActions.addImpactTypeSuccess, (state, action) => {
    const impType = state.impactTypes;
    const updatedState = {
      ...state,
      impactTypes: [...impType, action.impactTypes],
    };
    return updatedState;
  }),
  on(SaBiaActions.updateImpactTypeSuccess, (state, action) => {
    const impType = state.impactTypes.map((it) =>
      it.id == action.impactTypes.id ? action.impactTypes : it
    );

    const updatedState = {
      ...state,
      impactTypes: impType,
    };
    return updatedState;
  }),
  on(SaBiaActions.deleteImpactTypeSuccess, (state, action) => {
    return {
      ...state,
      impactTypes: state.impactTypes.filter(
        (impactType) => impactType.id !== action.impactType.id
      ),
    };
  }),
  on(SaBiaActions.addImpactValueSuccess, (state, action) => {
    const newTL = action.impactValue.isThresholdLevel;
    const newItId = action.impactValue.saImpactType.id;

    const impValue = state.impactValues.map((iv) =>
      newTL && newItId === iv.saImpactType.id
        ? {
            ...iv,
            isThresholdLevel: false,
          }
        : iv
    );
    const updatedState = {
      ...state,
      impactValues: [...impValue, action.impactValue],
    };
    return updatedState;
  }),
  on(SaBiaActions.updateImpactValueSuccess, (state, action) => {
    const newTL = action.impactValue.isThresholdLevel;
    const newItId = action.impactValue.saImpactType.id;
    const impVal = state.impactValues.map((iv) =>
      iv.id == action.impactValue.id
        ? action.impactValue
        : {
            ...iv,
            isThresholdLevel:
              newTL && newItId === iv.saImpactType.id
                ? false
                : iv.isThresholdLevel,
          }
    );

    const updatedState = {
      ...state,
      impactValues: impVal,
    };
    return updatedState;
  }),
  on(SaBiaActions.deleteImpactValueSuccess, (state, action) => {
    return {
      ...state,
      impactValues: state.impactValues.filter(
        (impactValue) => impactValue.id !== action.impactValue.id
      ),
    };
  }),
  on(SaBiaActions.updateImpactTemplateSuccess, (state, action) => {
    const updatedState = {
      ...state,
      impactTemplates: action.impactTemplates,
    };
    return updatedState;
  }),
  on(SaBiaActions.loadCriticalDefSuccess, (state, { criticalDef }) => ({
    ...state,
    criticalDef,
  }))
);
